export const roomTypesDictionary = ['Dbl Dorm', 'Dbl Private', 'Mixed Dorm', 'Female Dorm', 'Male Dorm', 'Private']


// WEBPACK FOOTER //
// ./src/config/roomTypesDictionary.js